/**
 * Data hook for the Operations Settled book surface.
 *
 *   useSettled() — polls GET /api/settled every 30s. Read-only in
 *   the skeleton; cases enter/leave the Settled book upstream (the portal
 *   and the staff doors).
 *
 * Polls at 30s like the Placed book, not the 15s of the routing worklists:
 * a settling case moves over hours and days (a check clears, a firm confirms
 * disbursement), not seconds, so there is nothing to gain from a tight
 * refresh.
 *
 * Spec: engineering/command-center/docs/port-notes/home-stretch.md (evicted 2026-08-29, #775 round 10)
 */

import { SettledResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useSettled = createPollingQuery({
  queryKey: ["settled"] as const,
  path: "/api/settled",
  schema: SettledResponseSchema,
  refetchIntervalMs: 30_000,
});
